import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { interval, Subscription, filter } from 'rxjs';

@Injectable()
export class PwaUpdateService implements OnDestroy {
  private readonly swUpdate = inject(SwUpdate);
  private readonly snackbar = inject(MatSnackBar);
  private readonly subscriptions = new Subscription();
  
  constructor() {
    this.initializeUpdateService();
  }

  private initializeUpdateService(): void {
    if (!this.swUpdate.isEnabled) {
      console.warn('Service Worker no está habilitado');
      return;
    }

    // Suscribirse a actualizaciones de versión
    this.subscriptions.add(
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY')
        )
        .subscribe(() => {
          console.log('Nueva versión disponible');
          this.showUpdateNotification();
        })
    );

    // Verificar actualizaciones periódicamente
    this.checkForUpdates();
  }

  private showUpdateNotification(): void {
    const snack = this.snackbar.open(
      'Nueva versión disponible', 
      'Actualizar', 
      {
        horizontalPosition: 'center',
        verticalPosition: 'top',
        duration: 0, // No se cierra automáticamente
      }
    );

    this.subscriptions.add(
      snack.onAction().subscribe(() => {
        window.location.reload();
      })
    );
  }

  private checkForUpdates(): void {
    console.log('Iniciando verificación periódica de actualizaciones');
    this.subscriptions.add(
      interval(5 * 60 * 1000) // Cada 5 minutos
        .subscribe(() => {
          console.log('Verificando actualizaciones...');
          this.swUpdate.checkForUpdate();
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
